var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline-break",class:{ 'start-border': _vm.startVisible, 'end-border': _vm.endVisible },style:(_vm.breakStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }